export const version = 1764835242017;
export default version;
